module.exports = __webpack_public_path__ + "img/【诊改行动】乘“数”而上，“捷”足先登！上电智联助力大捷实业开启轻量级数字化改造项目.d13501c0.jpg";